import $ from 'jquery';

jQuery(document).ready(function ($) {
  function updateCountdown() {
    const now = new Date().getTime();

    // Loop through each countdown element on the page
    $('.countdown-component').each(function () {
      const targetDateValue = $(this).data('countdown-date');
      const targetDate = new Date(targetDateValue).getTime();

      const distance = targetDate - now;

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      // Update the current countdown element
      $(this).find('.days').text(days);
      $(this).find('.hours').text(hours);
      $(this).find('.minutes').text(minutes);
      $(this).find('.seconds').text(seconds);

      if (distance < 0) {
        $(this).html('<p class="expired">Time\'s Up!</p>');
      }
    });
  }

  const interval = setInterval(updateCountdown, 1000);
});
